@import "../../global/normalize.css";

/**
 * @prop --ic-z-index-classification-banner: z-index of classification banner
 */

:host {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: var(--ic-space-lg);
  z-index: var(--ic-z-index-classification-banner);

  --ic-typography-color: currentcolor;
}

:host(.ic-classification-banner-inline) {
  position: static;
  left: auto;
  bottom: auto;
}

.classification-banner {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: var(--ic-space-xxxs) var(--ic-space-md);
}

.default {
  background-color: var(--ic-classification-banner-not-set);
  color: var(--ic-classification-banner-text-inverted);
}

.official {
  background-color: var(--ic-classification-banner-official);
  color: var(--ic-classification-banner-text-inverted);
}

.official-sensitive {
  background-color: var(--ic-classification-banner-official-sensitive);
  color: var(--ic-classification-banner-text-inverted);
}

.secret {
  background-color: var(--ic-classification-banner-secret);
  color: var(--ic-classification-banner-text);
}

.top-secret {
  background-color: var(--ic-classification-banner-top-secret);
  color: var(--ic-classification-banner-text-inverted);
}

.offscreen {
  position: absolute;
  left: -9999px;
  background-color: #fff;
  color: #000;
  text-transform: none;
}

.offscreen:dir(rtl) {
  right: -9999px;
}

@media (forced-colors: active) {
  .classification-banner {
    border: var(--ic-border-hc);
  }
}
